'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.span.withConfig({
  componentId: 's17caw90-0'
})(['display:inline-block;padding-left:calc(', ' * 1.5);line-height:1.5;top:-0.2em;position:relative;'], function (p) {
  return p.theme.spacingUnitCheckbox;
});